import { render, staticRenderFns } from "./super.vue?vue&type=template&id=5fd35484&scoped=true&"
import script from "./super.vue?vue&type=script&lang=js&"
export * from "./super.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd35484",
  null
  
)

export default component.exports